module.exports = __webpack_public_path__ + "static/prebuilt_cycling_plans_mobile-12005195146e164077c518b29ba05d0d.jpg";